import { ServiceLocation } from 'src/api/@generated/backend-api';

import { RootState } from 'src/state/types';
import { getOrThrow } from 'src/utils/type-utils';

export const selectSelectedServiceLocationOrThrow = (state: RootState): ServiceLocation =>
  getOrThrow(selectServiceLocation(state), 'Invalid state. Service location is not selected.');

export const selectServiceLocation = (state: RootState): ServiceLocation | undefined =>
  state.address.selectedServiceLocation;
